import { insertCertificate } from "../../../api/certificateAPI";
import Swal from "sweetalert2";

export const handleSubmit = async (
  e,
  name,
  imageUrl,
  organizer,
  link,
  status,
  type,
  toggleModal,
  category = ""
) => {
  e.preventDefault();

  if (!name) {
    Swal.fire({ icon: "error", title: "Oops...", text: "Nama sertifikat wajib diisi" });
    return;
  }

  try {
    Swal.fire({
      title: "Loading...",
      text: "Please wait while we add the certificate.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const statusAsInt = status ? 1 : 0;

    await insertCertificate({
      name,
      img: imageUrl,
      organizer,
      link,
      status: statusAsInt,
      type,
      category,
    });

    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Certificate added successfully",
    }).then(() => {
      window.location.reload(); 
    });

    toggleModal();
  } catch (error) {
    console.error("Failed to add certificate:", error.response ? error.response.data : error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to add certificate",
    });
  }
};
